import { useSelector } from "react-redux";
import LoginCompleteProfile from "../../login/render/Login.CompleteProfile";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ContextCart } from "../../../context/Context.Cart";
import { SystemStoreBasketAddress } from "../../../utils/useStorage";

const ProfileComplteProfile = () => {
  const { user } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const { cart } = React.useContext(ContextCart);
  const address = SystemStoreBasketAddress((state) => state.address);
  const selected = cart?.filter((item) => {
    return item.type === "PACKAGE";
  });

  React.useEffect(() => {
    document?.getElementById("first-div")?.scrollIntoView({
      block: "start",
    });
  }, []);

  React.useEffect(() => {
    document?.getElementById("first-div")?.scrollIntoView({
      block: "start",
    });

    // if (address && selected?.length > 0) {
    //   sessionStorage.setItem("payment", true);
    // }
    if (user?.full_name && user?.email && cart?.length > 0) {
      navigate("/Basket");
    } else if (user?.full_name && user?.email) {
      navigate("/OurServices");
    }
    return () => {};
  }, [user]);

  return (
    <LoginCompleteProfile
      mongoId={user?._id}
      username={user?.username}
      isCompltetePage={true}
    />
  );
};
export default ProfileComplteProfile;
